<template>
  <v-card
    class="mx-2 mt-2 mb-4 rounded-img"
    elevation="6"
    max-width="300"
    min-height="420"
  >
    <v-img :src="getImgUrl(img)" width="500" height="300" />
    <v-card-text>
      <strong> {{ title }} </strong>
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  props: {
    img: {
      type: String
    },
    title: {
      type: String
    }
  },
  methods: {
    getImgUrl(pic) {
      return require(`../assets/${pic}`);
    }
  }
};
</script>
<style scoped>
.rounded-img {
  border-radius: 10px;
}
.rounded-mini-img {
  border-radius: 5px;
}
</style>
